import { createSlice } from "@reduxjs/toolkit";

import {
  createCustomerSubscription,
  getCustomerSubscriptionById,
  getVirtualSpaces,
  getCustomerId,
  getCompanies,

  getCountries,
  getStates
} from "../actions"
import {
  createInstance,
  //callbackInstance,
  checkValidDomain
} from "./actions"

const initialState = {
  loadedFirstTime: false,
  loading: false,
  instancesRequested: false,
  instancesObtained: false,
  virtualSpaces: [],
  user: {},
  userRequested: false,
  userObtained: false,
  subscription: {},
  subscriptionObteined: false,
  targetRedirect: "",
  domainAvailable: true,
  companyTypes: [],
  companyTypesObtained: false,
  executionArn: "",
  redirect: false,

  countries: [],
  countriesRequested: false,
  countriesObtained: false,
  states: [],
  statesRequested: false
};

const createVSSlice = createSlice({
  name: "createVirtualSpaces",
  initialState: initialState,
  reducers: {
    resetCreateVirtualSpace: () => initialState,
    resetExecutionARN: (state) => {
      state.executionArn = ""
    },
    setRedirectStatus: (state) => {
      state.redirect = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCustomerSubscription.fulfilled, (state, action) => {
      state.user = action.payload.success? action.payload.data.customer : {};
      state.userObtained = action.payload.success ? true : false;
      state.userRequested = action.payload.success ? true : false;
      state.subscription = action.payload.success ? action.payload.data.subscription:{};
      state.subscriptionObteined = action.payload.success ? true: false;
    });

    builder.addCase(getCustomerSubscriptionById.fulfilled, (state, action) => {
      state.subscription = action.payload.success ? action.payload.data[0] : {};
      state.loadedFirstTime = state.userObtained && state.instancesObtained ? true : false;
    });
    builder.addCase(getCustomerSubscriptionById.pending, (state) => {
      state.subscriptionObteined = true;
    });

    builder.addCase(getCustomerId.fulfilled, (state, action) => {
      state.user = action.payload.success ? action.payload.data.customer : {};
      state.loadedFirstTime = state.subscriptionObteined && state.instancesObtained ? true : false;
      state.userObtained = action.payload.success ? true: false;
    });
    builder.addCase(getCustomerId.pending, (state) => {
      state.userRequested = true;
    });

    builder.addCase(getVirtualSpaces.fulfilled, (state, action) => {
      state.virtualSpaces = action.payload.success ? action.payload.data : [];
      state.loadedFirstTime = state.subscriptionObteined && state.userObtained ? true: false;
      state.instancesObtained = true;
    });
    builder.addCase(getVirtualSpaces.pending, (state) => {
      state.instancesRequested = true;
    });
    builder.addCase(getVirtualSpaces.rejected, (state) => {});

    builder.addCase(getCompanies.fulfilled, (state, action) => {
      state.companyTypes = action.payload.success ? action.payload.data : [];
    });
    builder.addCase(getCompanies.pending, (state) => {
      state.companyTypesObtained = true;
    });

    builder.addCase(createInstance.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(createInstance.fulfilled, (state, action) => {
      state.executionArn = action.payload && action.payload.executionArn ? action.payload.executionArn : "";
    })
    builder.addCase(createInstance.rejected, (state) => {
      state.loading = false;
    })

    /*
    builder.addCase(callbackInstance.fulfilled, (state, action) => {
      state.loading = false;
      state.executionArn = action.payload.success ? "" : state.executionArn;
      state.redirect = action.payload.success ? true : false;
    })
    builder.addCase(callbackInstance.rejected, (state) => {
      state.loading = false;
    })
    */

    builder.addCase(checkValidDomain.fulfilled, (state, action) => {
      state.domainAvailable = action.payload.available;
    });
    builder.addCase(checkValidDomain.pending, (state) => {});
    builder.addCase(checkValidDomain.rejected, (state) => {});

    builder.addCase(getCountries.pending, (state) => {
      state.countriesRequested = true
    })
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.countriesObtained = action.payload.success ? true : false;
      state.countries = action.payload.success ? action.payload.data : [];
    })
    builder.addCase(getCountries.rejected, (state, action) => {
    })

    builder.addCase(getStates.pending, (state) => {
      state.statesRequested = true;
    })
    builder.addCase(getStates.fulfilled, (state, action) => {
      state.states = action.payload.success ? action.payload.data : [];
    })
    builder.addCase(getStates.rejected, (state) => {})
  }
})

export const {
  resetCreateVirtualSpace, resetExecutionARN, setRedirectStatus } = createVSSlice.actions;
export default createVSSlice.reducer;